import { useState } from 'react';
import { Modal, Box, Button, Typography, FormControlLabel, Checkbox, TextField   } from '@mui/material';
import {styleModalEnviar} from "../../estilo/modal"

const ConfirmEnviarContModal = ({ open, handleClose, onConfirm }) => {
  const [sendEmail, setSendEmail] = useState(false);
  const [email, setEmail] = useState('');
  const [asunto, setAsunto] = useState('');
  const [mensaje, setMensaje] = useState('');

  const handleConfirmClick = () => {
    const customEmailData = sendEmail ?  { email, asunto, mensaje }: null;
    onConfirm(customEmailData);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={styleModalEnviar}>
        <Box mb={1} display="flex" justifyContent="center">
          <Typography variant="h6" component="h2">
            Enviar Contestación
          </Typography>
        </Box>
        <Typography align={"justify"} mb={2}>Las glosas tiene una entidad asociada y esta a su vez tiene asociado un correo electrónico. Por defecto las contestaciones se envían a este correo, pero si eliges la siguiente opción se puede modificar el destino y contenido del mensaje.</Typography>
        <FormControlLabel
          control={<Checkbox mb={2} checked={sendEmail} onChange={() => setSendEmail(!sendEmail)} />}
          label="Modificar correo" 
        />
        {sendEmail && (
          <>
            <TextField fullWidth label="Correo electrónico" value={email} onChange={(e) => setEmail(e.target.value)} sx={{ mt: 2 }} />
            <TextField fullWidth label="Asunto" value={asunto} onChange={(e) => setAsunto(e.target.value)} sx={{ mt: 2 }} />
            <TextField fullWidth label="Mensaje" value={mensaje} onChange={(e) => setMensaje(e.target.value)} sx={{ mt: 2, mb:2, fontSize: "1.1rem" }} multiline rows={7}/>
          </>
        )}
        <Typography mb={2}>¿Estás seguro de enviar la contestación de las facturas seleccionadas?</Typography>
        <Box display="flex" justifyContent="center">
          <Button variant="contained" color="primary" onClick={handleConfirmClick} sx={{background:'black'}}>
            Sí
          </Button>
          <Button variant="contained" color="secondary" onClick={handleClose} sx={{ marginLeft: 2, background:'gray'}}>
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmEnviarContModal;
